var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncompleteVideoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Incomplete_Video_Icon",
    "data-name": "Incomplete Video Icon",
    transform: "translate(4096 -900)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2783",
    "data-name": "Group 2783",
    transform: "translate(-5611 429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    transform: "translate(1515 471)",
    fill: "#fff",
    stroke: "#dceee4",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "sound_sampler_24dp_5F6368_FILL1_wght600_GRAD0_opsz24",
    d: "M62.586-884.171a8.079,8.079,0,0,1-1.331-2.337,7.893,7.893,0,0,1-.475-2.75,7.717,7.717,0,0,1,2.078-5.422,7.763,7.763,0,0,1,5.159-2.54v2.023a5.728,5.728,0,0,0-3.725,1.947,5.819,5.819,0,0,0-1.489,3.992,5.988,5.988,0,0,0,.319,1.97,6.005,6.005,0,0,0,.9,1.684Zm6.194,2.913a7.965,7.965,0,0,1-2.779-.48,7.885,7.885,0,0,1-2.346-1.354l1.425-1.444a6.049,6.049,0,0,0,1.7.922,5.951,5.951,0,0,0,2,.333,5.984,5.984,0,0,0,2.008-.333,5.9,5.9,0,0,0,1.7-.933l1.425,1.444a7.964,7.964,0,0,1-2.351,1.359A7.929,7.929,0,0,1,68.78-881.258Zm6.2-2.924-1.444-1.444a6.026,6.026,0,0,0,.9-1.679,5.908,5.908,0,0,0,.319-1.954,5.8,5.8,0,0,0-1.478-3.981,5.749,5.749,0,0,0-3.714-1.947v-2.034a7.766,7.766,0,0,1,5.148,2.55,7.726,7.726,0,0,1,2.067,5.411,7.848,7.848,0,0,1-.475,2.745A8.235,8.235,0,0,1,74.984-884.182Zm-8.2-1.49v-7.172l5.58,3.586Z",
    transform: "translate(-4150.78 1803.239)",
    fill: "#2f7373"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteVideoIcon);
export default __webpack_public_path__ + "static/media/Incomplete Video Icon.5017aa2f021758f04d531bb929692e94.svg";
export { ForwardRef as ReactComponent };